import { render, staticRenderFns } from "./BusquedaClientePerseo.vue?vue&type=template&id=047d27bf&scoped=true"
import script from "./BusquedaClientePerseo.vue?vue&type=script&lang=js"
export * from "./BusquedaClientePerseo.vue?vue&type=script&lang=js"
import style0 from "./BusquedaClientePerseo.vue?vue&type=style&index=0&id=047d27bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047d27bf",
  null
  
)

export default component.exports